// extracted by mini-css-extract-plugin
export var cardIcon = "_6x-5";
export var cardIconUnframed = "_6x-9";
export var checkboxCard = "_6x-0";
export var checkboxCardSelected = "_6x-4";
export var disabled = "_6x-2";
export var interactive = "_6x-1";
export var outerBorder = "_6x-3";
export var spacerMedium = "_6x-8";
export var spacerSmall = "_6x-7";
export var spacerXsmall = "_6x-6";